var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMobileMenuClose = function SvgMobileMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.197 6.197a.813.813 0 0 1 1.148 0L13 11.852l5.655-5.655a.812.812 0 1 1 1.148 1.148L14.148 13l5.655 5.655a.813.813 0 1 1-1.148 1.148L13 14.148l-5.655 5.655a.813.813 0 0 1-1.148-1.148L11.852 13 6.197 7.345a.813.813 0 0 1 0-1.148Z",
    fill: "#232020"
  })));
};

export default SvgMobileMenuClose;